import React, { Dispatch, SetStateAction } from 'react';
import { useIntl } from 'react-intl';
import { isNuEar } from '../../../hooks/nuear-hook';
import SelectInput from '../../inputs/select-input';
import TextInput from '../../inputs/text-input';
import { IConstants, ISession } from '../../../models/pro-sites';
import {
    IServiceRequestOptions,
    IServiceRequestInitial,
    getShipToDropShipInitial,
    getShipToUpper,
} from '../../../models/service-request';
import { IAccountBillTo } from '../../../models/account';
import {
    useCountry,
    useCurrentBillTo,
    useCurrentShipTo,
} from '../../../hooks/service-request-hooks';
import { US } from '../../common/constants';
import { ServiceRequestFormErrors } from './validation';
interface IServiceRequestAccountInfoProps {
    session: ISession | null;
    constants: IConstants;
    serviceRequest: IServiceRequestInitial;
    setServiceRequest: Dispatch<SetStateAction<IServiceRequestInitial>>;
    billToAccounts: IAccountBillTo[];
    billToOptions: IServiceRequestOptions[];
    shipToOptions: IServiceRequestOptions[];
    serviceOptions: IServiceRequestOptions[];
    shippingOptions: IServiceRequestOptions[];
    errors: ServiceRequestFormErrors;
}
const ServiceRequestAccountInfo = ({
    session,
    constants,
    serviceRequest,
    setServiceRequest,
    billToAccounts,
    billToOptions,
    shipToOptions,
    serviceOptions,
    shippingOptions,
    errors,
}: IServiceRequestAccountInfoProps) => {
    const intl = useIntl();
    const currentBillTo = useCurrentBillTo(
        billToAccounts,
        serviceRequest.billTo.AccountNumber
    );
    const currentShipto = useCurrentShipTo(
        currentBillTo?.shipToAccounts,
        serviceRequest.shipTo.FullAccountNumber
    );

    const country = useCountry(constants, session);

    return (
        <>
            {session && currentBillTo && (
                <div className="well gutter-top">
                    <h3
                        className={
                            isNuEar(session!.siteNumber) ? 'nuEar' : 'starkey'
                        }
                        style={{ color: '#58595b' }}
                    >
                        {intl.formatMessage({
                            id: 'Account_Information',
                            defaultMessage: 'Account Information',
                        })}
                    </h3>
                    <div className="form-horizontal">
                        <SelectInput
                            name="billToAccount"
                            label="Bill To Account"
                            labelClassName="control-label col-sm-4 col-md-3"
                            fieldClassName="col-sm-8 col-md-6"
                            options={billToOptions}
                            hasDefaultOption={false}
                            onChange={(e) => {
                                e.persist();
                                const billTo = billToAccounts.find(
                                    (billToAccount) =>
                                        billToAccount.accountNumber ===
                                        e.target.value
                                );
                                if (billTo)
                                    setServiceRequest((serviceRequest) => ({
                                        ...serviceRequest,
                                        billTo: {
                                            AccountNumber: billTo.accountNumber,
                                            FullAccountNumber:
                                                billTo.fullAccountNumber,
                                            PartyName: billTo.partyName,
                                        },
                                        shipTo: getShipToUpper(
                                            billTo.shipToAccounts[0]
                                        ),
                                    }));
                            }}
                            required={false}
                        />
                        <div className="form-group">
                            <label className="control-label col-sm-4 col-md-3">
                                {intl.formatMessage({
                                    id: 'Address',
                                    defaultMessage: 'Address',
                                })}
                                :
                            </label>
                            <p
                                className="form-control-static col-sm-8 col-md-6"
                                style={{ color: '#58595b' }}
                            >
                                <span>{currentBillTo.partyName}</span>
                                <br></br>
                                <span>{currentBillTo.street1}</span>
                                <br></br>
                                <span>{currentBillTo.city}</span>,{' '}
                                <span>{currentBillTo.state}</span>{' '}
                                <span>{currentBillTo.postalCode}</span>
                            </p>
                        </div>
                        <SelectInput
                            name="shipToAccount"
                            label="Ship To Account"
                            labelClassName="control-label col-sm-4 col-md-3"
                            fieldClassName="col-sm-8 col-md-6"
                            options={shipToOptions}
                            hasDefaultOption={false}
                            onChange={(e) => {
                                e.persist();
                                if (e.target.value === '-1') {
                                    setServiceRequest((serviceRequest) => ({
                                        ...serviceRequest,
                                        shipTo: getShipToDropShipInitial(
                                            'Other ...',
                                            session.country
                                        ),
                                    }));
                                } else {
                                    const billTo = billToAccounts.find(
                                        (billToAccount) =>
                                            billToAccount.accountNumber ===
                                            serviceRequest.billTo.AccountNumber
                                    );
                                    if (billTo) {
                                        const shipTo =
                                            billTo.shipToAccounts.find(
                                                (shipToAccount) =>
                                                    shipToAccount.fullAccountNumber ===
                                                    e.target.value
                                            );

                                        if (shipTo)
                                            setServiceRequest(
                                                (serviceRequest) => ({
                                                    ...serviceRequest,
                                                    shipTo: getShipToUpper(
                                                        shipTo
                                                    ),
                                                })
                                            );
                                    }
                                }
                            }}
                            required={false}
                        />
                        {constants &&
                            (serviceRequest.shipTo.FullAccountNumber !==
                            'Other ...' ? (
                                <div className="form-group">
                                    <label className="control-label col-sm-4 col-md-3">
                                        {intl.formatMessage({
                                            id: 'Address',
                                            defaultMessage: 'Address',
                                        })}
                                        :
                                    </label>
                                    <p
                                        className="form-control-static col-sm-8 col-md-6"
                                        style={{ color: '#58595b' }}
                                    >
                                        <span>
                                            {currentShipto
                                                ? currentShipto.partyName
                                                : currentBillTo
                                                      .shipToAccounts[0]
                                                      .partyName}
                                        </span>
                                        <br></br>
                                        <span>
                                            {currentShipto
                                                ? currentShipto.street1
                                                : currentBillTo
                                                      .shipToAccounts[0]
                                                      .street1}
                                        </span>
                                        <br></br>
                                        <span>
                                            {currentShipto
                                                ? currentShipto.city
                                                : currentBillTo
                                                      .shipToAccounts[0].city}
                                        </span>
                                        ,{' '}
                                        <span>
                                            {currentShipto
                                                ? currentShipto.state
                                                : currentBillTo
                                                      .shipToAccounts[0].state}
                                        </span>{' '}
                                        <span>
                                            {currentShipto
                                                ? currentShipto.postalCode
                                                : currentBillTo
                                                      .shipToAccounts[0]
                                                      .postalCode}
                                        </span>
                                    </p>
                                </div>
                            ) : (
                                <>
                                    <TextInput
                                        name="street1"
                                        label="Address"
                                        labelClassName="control-label col-sm-4 col-md-3"
                                        fieldClassName="col-sm-8 col-md-6"
                                        value={serviceRequest.shipTo.Street1}
                                        maxLength={240}
                                        onChange={(e) => {
                                            e.persist();
                                            setServiceRequest(
                                                (serviceRequest) => ({
                                                    ...serviceRequest,
                                                    shipTo: {
                                                        ...serviceRequest.shipTo,
                                                        Street1: e.target.value,
                                                    },
                                                })
                                            );
                                        }}
                                        required={true}
                                        isOldStyleRequired={true}
                                        error={
                                            errors.Street1
                                                ? errors.Street1
                                                : undefined
                                        }
                                    />
                                    <TextInput
                                        name="street2"
                                        label=""
                                        labelClassName="control-label col-sm-4 col-md-3"
                                        fieldClassName="col-sm-8 col-md-6"
                                        value={serviceRequest.shipTo.Street2}
                                        maxLength={240}
                                        onChange={(e) => {
                                            e.persist();
                                            setServiceRequest(
                                                (serviceRequest) => ({
                                                    ...serviceRequest,
                                                    shipTo: {
                                                        ...serviceRequest.shipTo,
                                                        Street2: e.target.value,
                                                    },
                                                })
                                            );
                                        }}
                                    />
                                    <TextInput
                                        name="city"
                                        label="City"
                                        labelClassName="control-label col-sm-4 col-md-3"
                                        fieldClassName="col-sm-8 col-md-6"
                                        value={serviceRequest.shipTo.City}
                                        maxLength={60}
                                        onChange={(e) => {
                                            e.persist();
                                            setServiceRequest(
                                                (serviceRequest) => ({
                                                    ...serviceRequest,
                                                    shipTo: {
                                                        ...serviceRequest.shipTo,
                                                        City: e.target.value,
                                                    },
                                                })
                                            );
                                        }}
                                        required={true}
                                        isOldStyleRequired={true}
                                        error={
                                            errors.City
                                                ? errors.City
                                                : undefined
                                        }
                                    />
                                    {serviceRequest.shipTo.Country === US ? (
                                        <SelectInput
                                            name="state"
                                            label="State/Province"
                                            labelClassName="control-label col-sm-4 col-md-3"
                                            fieldClassName="col-sm-8 col-md-6"
                                            options={constants.states.map(
                                                (state) => ({
                                                    value: state.code,
                                                    text: state.name,
                                                })
                                            )}
                                            hasDefaultOption={true}
                                            defaultOption="Select ..."
                                            value={serviceRequest.shipTo.State}
                                            onChange={(e) => {
                                                e.persist();
                                                setServiceRequest(
                                                    (serviceRequest) => ({
                                                        ...serviceRequest,
                                                        shipTo: {
                                                            ...serviceRequest.shipTo,
                                                            State: e.target
                                                                .value,
                                                        },
                                                    })
                                                );
                                            }}
                                            required={false}
                                            error={
                                                errors.State
                                                    ? errors.State
                                                    : undefined
                                            }
                                        />
                                    ) : (
                                        <TextInput
                                            name="state"
                                            label="State/Province"
                                            labelClassName="control-label col-sm-4 col-md-3"
                                            fieldClassName="col-sm-8 col-md-6"
                                            value={serviceRequest.shipTo.State}
                                            maxLength={60}
                                            onChange={(e) => {
                                                e.persist();
                                                setServiceRequest(
                                                    (serviceRequest) => ({
                                                        ...serviceRequest,
                                                        shipTo: {
                                                            ...serviceRequest.shipTo,
                                                            State: e.target
                                                                .value,
                                                        },
                                                    })
                                                );
                                            }}
                                            required={true}
                                            isOldStyleRequired={true}
                                            error={
                                                errors.State
                                                    ? errors.State
                                                    : undefined
                                            }
                                        />
                                    )}
                                    <TextInput
                                        name="postalCode"
                                        label="Postal Code"
                                        labelClassName="control-label col-sm-4 col-md-3"
                                        fieldClassName="col-sm-8 col-md-6"
                                        value={serviceRequest.shipTo.PostalCode}
                                        maxLength={11}
                                        onChange={(e) => {
                                            e.persist();
                                            setServiceRequest(
                                                (serviceRequest) => ({
                                                    ...serviceRequest,
                                                    shipTo: {
                                                        ...serviceRequest.shipTo,
                                                        PostalCode:
                                                            e.target.value,
                                                    },
                                                })
                                            );
                                        }}
                                        required={true}
                                        isOldStyleRequired={true}
                                        error={
                                            errors.PostalCode
                                                ? errors.PostalCode
                                                : undefined
                                        }
                                    />
                                    <SelectInput
                                        name="country"
                                        label="Country"
                                        labelClassName="control-label col-sm-4 col-md-3"
                                        fieldClassName="col-sm-8 col-md-6"
                                        options={constants.countries.map(
                                            (country) => ({
                                                value: country.code,
                                                text: country.name,
                                            })
                                        )}
                                        hasDefaultOption={true}
                                        defaultOption={country}
                                        value={serviceRequest.shipTo.Country}
                                        onChange={(e) => {
                                            e.persist();
                                            setServiceRequest(
                                                (serviceRequest) => ({
                                                    ...serviceRequest,
                                                    shipTo: {
                                                        ...serviceRequest.shipTo,
                                                        Country: e.target.value,
                                                    },
                                                })
                                            );
                                        }}
                                        required={false}
                                    />
                                </>
                            ))}
                        <SelectInput
                            name="shipping"
                            label="Shipping"
                            labelClassName="control-label col-sm-4 col-md-3"
                            fieldClassName="col-sm-8 col-md-6"
                            options={shippingOptions}
                            hasDefaultOption={false}
                            onChange={(e) => {
                                e.persist();
                                setServiceRequest((serviceRequest) => ({
                                    ...serviceRequest,
                                    shippingOption: e.target.value,
                                }));
                            }}
                            required={false}
                        />
                        <SelectInput
                            name="serviceOption"
                            label="Service Option"
                            labelClassName="control-label col-sm-4 col-md-3"
                            fieldClassName="col-sm-8 col-md-6"
                            options={serviceOptions}
                            hasDefaultOption={false}
                            onChange={(e) => {
                                e.persist();
                                setServiceRequest((serviceRequest) => ({
                                    ...serviceRequest,
                                    serviceOption: e.target.value,
                                }));
                            }}
                            required={false}
                        />
                        <TextInput
                            name="contactName"
                            label="Contact Name"
                            labelClassName="control-label col-sm-4 col-md-3"
                            fieldClassName="col-sm-8 col-md-6"
                            value={serviceRequest.contactName}
                            maxLength={40}
                            onChange={(e) => {
                                e.persist();
                                setServiceRequest((serviceRequest) => ({
                                    ...serviceRequest,
                                    contactName: e.target.value,
                                }));
                            }}
                            required={true}
                            isOldStyleRequired={true}
                            error={
                                errors.contactName
                                    ? errors.contactName
                                    : undefined
                            }
                        />
                        <TextInput
                            name="contactPhone"
                            label="Phone Number"
                            labelClassName="control-label col-sm-4 col-md-3"
                            fieldClassName="col-sm-8 col-md-6"
                            value={serviceRequest.contactPhone}
                            maxLength={20}
                            onChange={(e) => {
                                e.persist();
                                setServiceRequest((serviceRequest) => ({
                                    ...serviceRequest,
                                    contactPhone: e.target.value.replaceAll(
                                        /[^0-9\(\)\-\. ]/g,
                                        ''
                                    ),
                                }));
                            }}
                            required={true}
                            isOldStyleRequired={true}
                            error={
                                errors.contactPhone
                                    ? errors.contactPhone
                                    : undefined
                            }
                        />
                        <TextInput
                            name="poNumber"
                            label="P O Number"
                            labelClassName="control-label col-sm-4 col-md-3"
                            fieldClassName="col-sm-8 col-md-6"
                            value={serviceRequest.poNumber}
                            maxLength={50}
                            onChange={(e) => {
                                e.persist();
                                setServiceRequest((serviceRequest) => ({
                                    ...serviceRequest,
                                    poNumber: e.target.value,
                                }));
                            }}
                            required={
                                serviceRequest.shipTo.PoRequiredTypes &&
                                session.country === US
                                    ? true
                                    : false
                            }
                            isOldStyleRequired={true}
                            error={
                                errors.poNumber ? errors.poNumber : undefined
                            }
                        />
                        <TextInput
                            name="referenceNumber"
                            label="Reference #"
                            labelClassName="control-label col-sm-4 col-md-3"
                            fieldClassName="col-sm-8 col-md-6"
                            value={serviceRequest.referenceNumber}
                            maxLength={25}
                            onChange={(e) => {
                                e.persist();
                                setServiceRequest((serviceRequest) => ({
                                    ...serviceRequest,
                                    referenceNumber: e.target.value,
                                }));
                            }}
                            required={false}
                        />
                    </div>
                </div>
            )}
        </>
    );
};

export default ServiceRequestAccountInfo;
